import PropTypes from "prop-types";
import { useHistory } from "react-router-dom";
import { roleModuleAction, roleModuleFilter } from "./constants";


export function hasFilteredRolePermission({ rol, userId, userCreatedId, moduleAction }) {
    const rolActions = roleModuleFilter.find((r) => r.Rol === rol);
    if (!rolActions) return false;
    return rolActions.Full || (rolActions.Filters.includes(moduleAction) && userId === userCreatedId);
}



export function ShowForRoleComponent({ rol, accessPermission, moduleAction, children }) {
    const history = useHistory();
    const rolActions = roleModuleAction.find((r) => r.Rol == rol);

    const hasPermission =
        (accessPermission === undefined && moduleAction === undefined) ||
            (accessPermission === null && moduleAction === null)
            ? true
            : rolActions?.Full ||
            (accessPermission && rolActions?.Actions.includes(accessPermission)) ||
            (moduleAction && rolActions?.Actions.includes(moduleAction));

    if (accessPermission && !hasPermission) {
        history.replace("/dashboard");
    }

    return hasPermission ? children : null;
};

ShowForRoleComponent.propTypes = {
    rol: PropTypes.number.isRequired,
    accessPermission: PropTypes.string,
    moduleAction: PropTypes.string,
};
